module.exports = __webpack_public_path__ + "static/media/AAJ-swift-logo-white.8a55fe66.png";